import { ListRfqsReq } from '../repositories/drfq-types';
import { Drfq } from '../entities/drfq/domain';
import { DrfqDraftsStore } from '../store/drfq-drafts';
import { MergedSourcesFetcher } from './merged-sources-fetcher';
import { DrfqService } from './drfq';

interface DrfqDraftsServiceDeps {
  drfqDraftsStore: DrfqDraftsStore;
  drfqService: DrfqService;
}

export class DrfqDraftsService {
  public fetcher: MergedSourcesFetcher<ListRfqsReq, Drfq>;

  constructor(deps: DrfqDraftsServiceDeps) {
    this.fetcher = new MergedSourcesFetcher({
      fetchers: [deps.drfqService.listDrfqDrafts],
      store: deps.drfqDraftsStore,
      pageSize: 50,
    });
  }
}
